import '@atlaskit/css-reset'
import Spinner from '@atlaskit/spinner'
import { Global, css } from '@emotion/react'
import jwtDecode from 'jwt-decode'
import * as React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ErrorBoundary from './ErrorBoundary'
import { ExportToExcel } from './apps/ExportToExcel'
import { NotFound } from './apps/NotFound'
import { OpenInExcel } from './apps/OpenInExcel'
import { OpenInGSheets } from './apps/OpenInGSheets'
import { ExportToProvider } from './context/ExportToContext'
import { Init } from './services/AnalyticsClient'
import { getUserInfo } from './services/JiraAP'

function App() {
  const [isLoading, setLoading] = React.useState(true)

  React.useEffect(() => {
    async function init() {
      if (window?.AP?.getUserInfo) {
        // started inside Jira's dialog
        const { atlassianAccountId } = await getUserInfo()

        Init(atlassianAccountId)
      } else {
        const locationSearchParams = new URLSearchParams(window.location.search)
        const jiraToken = locationSearchParams.get('jwt')

        if (jiraToken) {
          const aaid = jwtDecode(jiraToken).sub

          Init(aaid)
        }
      }

      setLoading(false)
    }

    init()
  }, [])

  if (isLoading) return <Spinner />

  return (
    <Routes>
      <Route element={<OpenInExcel />} path='/open-in-excel' />
      <Route element={<OpenInGSheets />} path='/open-in-gsheets' />
      <Route
        element={
          <ExportToProvider>
            <ExportToExcel />
          </ExportToProvider>
        }
        path='/export-to-excel'
      />
      <Route
        element={
          <ExportToProvider>
            <ExportToExcel downloadInProgress />
          </ExportToProvider>
        }
        path='/download-in-progress'
      />
      <Route
        element={
          <ExportToProvider>
            <ExportToExcel uploadInProgress />
          </ExportToProvider>
        }
        path='/upload-in-progress'
      />
      <Route element={<NotFound />} path='*' />
    </Routes>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Global styles={css({ '#root': { height: '100%' } })} />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
)
